export default __webpack_public_path__ + "static/media/polydoge.74b2c771.png";